export default "__VITE_ASSET__B7HI4jlc__";